export default __webpack_public_path__ + "static/media/google-cloud-admin.c5a6a43d.svg";